import Stack from 'atoms/Layout/Stack/Stack';
import PricingCardsWithSelection from 'molecules/PricingCardsWithSelection/PricingCardsWithSelection';
import PricingQuizModal from 'molecules/PricingQuizModal/PricingQuizModal';
import React from 'react';
import { IPricingCard } from 'src/hooks/usePricingCards';
import usePricingQuizModalController from 'src/hooks/usePricingQuizModalController';

interface PricingCardsWithQuizProps {
  pricingItems: IPricingCard[];
  priceBlockMinHeight?: number;
  activePriceMode: 'monthly' | 'annual';
  setActivePriceMode: (activePriceMode: 'monthly' | 'annual') => void;
}

const PricingCardsWithQuiz = ({
  pricingItems,
  activePriceMode,
  priceBlockMinHeight,
  setActivePriceMode,
}: PricingCardsWithQuizProps): JSX.Element => {
  const { displayPricingQuiz, quizIsOpen, skipIntro } = usePricingQuizModalController(false);

  const tabs = [
    {
      label: 'Monthly billing',
      onClick: () => setActivePriceMode('monthly'),
      isSelected: activePriceMode === 'monthly',
    },
    {
      label: 'Annual billing',
      badge: 'Save 20%',
      onClick: () => setActivePriceMode('annual'),
      isSelected: activePriceMode === 'annual',
    },
  ];

  return (
    <Stack
      padding={['spacing-none', 'spacing-none']}
      paddingXl={['spacing-none', 'spacing-xl']}
      margin={['spacing-none', 'spacing-auto']}
    >
      <PricingCardsWithSelection
        tabs={tabs}
        pricingCards={pricingItems}
        priceBlockMinHeight={priceBlockMinHeight}
        pricingQuiz={{
          text: {
            type: 'paragraph',
            size: 'xl',
            fontWeight: 'font-weight-semibold',
            text: 'Which plan is right for you?',
          },
          onClick: displayPricingQuiz(true),
        }}
      />
      <PricingQuizModal
        visible={quizIsOpen}
        onClose={displayPricingQuiz(false)}
        skipIntro={skipIntro}
      />
    </Stack>
  );
};

export default PricingCardsWithQuiz;
